module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/wasm-module.66fa2b88895235c80f86.js");
};